import React, { useState } from 'react';
import Auth from 'j-toker';

import RentersInsuranceList from './todos/RentersInsuranceList';
import RentersInsuranceUploader from './todos/RentersInsuranceUploader';
import { NueraDialog, redirectToNuera } from '../InsuranceDialog';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Icon, { LoadingOutlined } from '@ant-design/icons';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { apiGet } from 'helpers/ApiHelper';
import { featureEnabled } from 'helpers/ToggleBot';

const ViewEditRentersInsuranceDialog = ({
  dialogOpen,
  toggleDialog,
  insuranceDetails,
  deleteDocument,
  editDocument,
  canPurchaseInsurance,
  createTenantDocument,
  address,
  tenantOverview,
  leaseStartDate,
  showFailure,
}) => {
  const [loadingPurchase, setLoadingPurchase] = useState(false);
  const [nueraDialog, toggleNueraDialog] = useState(false);
  const [insuranceUploaderDialog, toggleInsuranceUploaderDialog] = useState(false);
  const isMobile = window.matchMedia('(max-width: 750px)').matches;

  const redirectPurchaseInsurance = async () => {
    setLoadingPurchase(true);
    if (featureEnabled('apollo_insurance')) {
      try {
        const { provider_url } = await apiGet(
          `${Auth.getApiUrl()}/leads/insurance/provider_redirect`
        );

        window.open(provider_url, '_blank');
      } catch (error) {
        showFailure(error);
      }
    } else {
      // TODO: remove when apollo insurance is confirmed as both nuera and apollo will use this backend
      //       endpoint above to fetch redirect
      redirectToNuera({
        leaseStartDate: leaseStartDate,
        birthday: tenantOverview.birthday,
        email: tenantOverview.email,
        phoneNumber: tenantOverview.phone_number,
        tenantId: tenantOverview.cotenant_id,
        ...address,
      });
    }
    setLoadingPurchase(false);
  };
  return (
    <div>
      <NueraDialog
        isOpen={nueraDialog}
        toggleDialog={() => toggleNueraDialog(!nueraDialog)}
        {...address}
        leaseStartDate={leaseStartDate}
        birthday={tenantOverview.birthday}
        email={tenantOverview.email}
        phoneNumber={tenantOverview.phone_number}
        tenantId={tenantOverview.cotenant_id}
        fullScreen={isMobile}
      />
      <RentersInsuranceUploader
        dialogOpen={insuranceUploaderDialog}
        toggleDialog={() => toggleInsuranceUploaderDialog(!insuranceUploaderDialog)}
        onSubmit={createTenantDocument}
      />
      <Dialog
        disableBackdropClick
        open={dialogOpen}
        onClose={toggleDialog}
        aria-labelledby="add-new-document"
        classes={{
          paper: 'form-dialog',
        }}
        fullScreen={isMobile}
      >
        <DialogTitle style={{ paddingBottom: '0px' }} id="upload-document">
          <h3>
            {getTranslatedString('tenantPortal.viewEditRentersInsuranceDialog.rentersInsurance')}
          </h3>
          <h5 style={{ fontFamily: 'Circular' }}>
            {getTranslatedString('tenantPortal.viewEditRentersInsuranceDialog.theseDocuments')}
          </h5>
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              borderTop: `2.5px solid ${AccentColor()}`,
              paddingTop: '20px',
            }}
          />
          {insuranceDetails && (
            <RentersInsuranceList
              deleteDocument={deleteDocument}
              editDocument={editDocument}
              insuranceDetails={insuranceDetails}
            />
          )}
        </DialogContent>

        <DialogActions style={{ display: 'block' }}>
          <div>
            <FlatButton onClick={toggleDialog} id="close-button" style={{ color: AccentColor() }}>
              {getTranslatedString('tenantPortal.viewEditRentersInsuranceDialog.cancel')}
            </FlatButton>
          </div>
          <div>
            {canPurchaseInsurance && (
              <FlatButton
                variant="raised"
                onClick={redirectPurchaseInsurance}
                id="submit-button"
                style={{
                  color: 'white',
                  backgroundColor: AccentColor(),
                }}
                disabled={loadingPurchase}
              >
                {loadingPurchase && <Icon component={LoadingOutlined} spin />}{' '}
                {getTranslatedString('tenantPortal.viewEditRentersInsuranceDialog.purchase')}
              </FlatButton>
            )}
            <FlatButton
              variant="raised"
              onClick={toggleInsuranceUploaderDialog}
              id="submit-button"
              style={{
                color: canPurchaseInsurance ? AccentColor() : 'white',
                backgroundColor: canPurchaseInsurance ? 'white' : AccentColor(),
              }}
            >
              {getTranslatedString('tenantPortal.viewEditRentersInsuranceDialog.upload')}
            </FlatButton>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ViewEditRentersInsuranceDialog;
